import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type Site } from '../services/siteListService'

export interface SiteListState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  sites: Site[]
}

const initialState: SiteListState = {
  isLoading: true,
  error: null,
  httpStatus: null,
  sites: []
}

// istanbul ignore next
const siteListSlice = createSlice({
  name: 'tiqSiteList',
  initialState,
  reducers: {
    siteListLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        sites: []
      }
    },
    siteListUpdateAction: (state, action: PayloadAction<{ data: Site[], httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        sites: action.payload.data
      }
    },
    siteListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        sites: []
      }
    }
  }
})

export const {
  siteListLoadingAction,
  siteListUpdateAction,
  siteListErrorAction
} = siteListSlice.actions

export default siteListSlice.reducer
